import BlogGridView from "../../../commonComponents/blogGridView";

const BlogTitleContainer = () => {
  return <BlogGridView sectionClass="blog-title-layout" type="title_box" />;
};

export default BlogTitleContainer;
